/** The longest note a person can leave for the model on a reading they ask for. */
export const QUESTION_DIGITISATION_RUN_NOTE_MAX_LENGTH = 500;

/** The first rung of the engine's retry ladder, which the survey opens. */
export const FIRST_DIGITISATION_RUNG = 1;

/** The last rung of the engine's retry ladder, after which a question waits for a person. */
export const LAST_DIGITISATION_RUNG = 3;

/**
 * The key in a run's `stats` listing the questions that lost a relationship a
 * person had set into the trees the run replaced.
 */
export const RELATIONSHIP_OVERRIDES_LOST_STAT = 'relationshipOverridesLostBy';
